import React from "react";
import PropTypes from "prop-types";

const statusText = scrapReportStatus => {
  if (scrapReportStatus) {
    return "Received";
  }
  return "Awaiting";
};

const labelStyle = scrapReportStatus => {
  if (scrapReportStatus) {
    return { color: "#4caf50" };
  }

  return {};
};

const icon = scrapReportStatus => {
  if (scrapReportStatus) {
    return <i className="fa fa-check" />;
  }
  return null;
};

export default function ScrapReportStatusLabel({ scrapReportStatus }) {
  return (
    <span style={labelStyle(scrapReportStatus)}>
      {icon(scrapReportStatus)} {statusText(scrapReportStatus)}
    </span>
  );
}

ScrapReportStatusLabel.propTypes = {
  scrapReportStatus: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/ScrapReportStatusLabel.jsx